import React from 'react';
import Form from './components/Form/index.jsx';

function App() {
  return (
    <div className="App">
      <Form />
    </div>
  );
}

export default App;
